import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {FormlyModule} from '@ngx-formly/core';
import {I18nModule} from '@spartacus/core';
import {FormlyEuAccessComponent} from './eu-access.component';
import {IconButtonTooltipComponent} from '@dcp/configurator';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
  imports: [
    I18nModule,
    AsyncPipe,
    FormlyModule.forChild({
      types: [
        {
          name: 'eu-access',
          component: FormlyEuAccessComponent,
        },
      ],
    }),
    IconButtonTooltipComponent,
    ReactiveFormsModule,
    FormlyEuAccessComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EuAccessModule {}
